export const urls = {
  commonPages: {
    home: '/',
    challenges: '/challenges-feed',
    debateCard: '/debate-card',
    challengeCard: '/challenge-card',
    help: '/help',
    about: '/about',
    stream: '/stream',
    emailVerify: '/email-verify',
    passwordResetConfirm: '/password-reset-confirm',
    generateTopics: '/generate-topics',
    privacyPolicy: '/privacy-policy',
    termsAndConditions: '/terms-and-conditions',
    ConsentToDataProcessing: '/consent-to-data-processing',
    communityGuidelines: '/community-guidelines',
  },
  myPages: {
    profile: '/profile',
    myChallenges: '/my-challenges',
    myDebates: '/my-debates',
    help: '/profile-help',
    video: '/video',
  },
  otherLinks: {
    // TODO: add the following link
    // B2B: 'ADD-B2B-LINK',
    socialLinks: {
      discord: 'https://discord.gg/EZdQcxTVUK',
      twitter: 'https://x.com/Deb8tv',
    },
  },
};
